// extracted by mini-css-extract-plugin
module.exports = {"controlCell":"style_controlCell__1SKR-","lastColumn":"style_lastColumn__oFUgf","scopeCell":"style_scopeCell__VU5X2","fullSizeCell":"style_fullSizeCell__31kbr"};